<template>
  <v-select
    class="select-box"
    :options="options"
    :label="label"
    :closeOnSelect="true"
    v-model="input"
    :multiple="multiple"
    :searchable="searchable"
    :loading="loading"
    @open="onOpen"
    :filterable="searchableSimple"
    @search="search"
    @close="onClose"
    :reduce="(option) => (select ? option[select] : option)"
    :placeholder="placeHolder"
    :disabled="disabled"
  >
    <template #option="data">
      <div>
        <slot :data="data" v-if="hasSlot" />
        <template v-else>
          {{ data[label] }}
        </template>
      </div>
    </template>
    <template #selected-option="data" v-if="hasSlotSelectedOption">
      <slot name="selectedOption" :data="data" />
    </template>
    <template #spinner="{ loading }">
      <div
        class="w-full animate-pulse flex justify-center items-center"
        v-if="loading"
      >
        <div
          class="mx-0.5 w-4 h-4 bg-slate-400 rounded-full"
          v-for="i in 3"
          :key="i"
        ></div>
      </div>
    </template>
    <template #list-footer>
      <li
        v-show="hasNextPage && options.length > 0"
        ref="load"
        class="loader w-100 px-2"
      >
        <span> loading... </span>
      </li>
    </template>
    <template #no-options> no options </template>
  </v-select>
</template>

<script>
import vSelect from "vue-select";
import qs from "qs";
export default {
  components: {
    vSelect,
  },
  props: {
    loader: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    searchable: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "",
    },
    select: {
      type: String,
      default: "",
    },
    option: {
      type: String,
      default: "",
    },
    lists: {
      type: Array,
      default: () => [],
    },
    url: {
      type: String,
      default: "",
    },
    value: {
      type: null,
    },

    placeHolder: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hasSlot: {
      type: Boolean,
      default: false,
    },
    searchableSimple: {
      type: Boolean,
      default: false,
    },
    hasSlotSelectedOption: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    lists(newVal) {
      this.options = newVal;
    },
    loader(newVal) {
      this.loading = newVal;
    },
    async url(newVal) {
      this.loading = true;
      this.input = await "";
      this.pagination = await {};
      this.options = await [];
      await delete this.query.page;
      await this.getOptions();
      this.loading = false;
    },
  },
  data() {
    return {
      observer: null,
      options: [],
      openDropDown: false,
      loading: false,
      pagination: {},
      query: {},
      isRequesting: false,
    };
  },

  async created() {
    this.loading = true;
    if (this.url) {
      if (Array.isArray(this.value)) {
        if (this.value.length) {
          await this.getEditOptions();
        }
      } else if (this.value) {
        await this.getEditOptions();
      }

      await this.getOptions();
    } else {
      this.options = await this.lists;
    }
    this.loading = false;
  },
  mounted() {
    this.observer = new IntersectionObserver(this.infiniteScroll);
  },

  methods: {
    debounceEvent(callback, keyword, time) {
      clearTimeout(this.interval);
      this.interval = setTimeout(() => {
        this.interval = null;
        callback(keyword);
      }, time);
    },
    async getOptionsOnSearch(search) {
      this.loading = true;
      this.options = await [];
      if (this.url) {
        if (Array.isArray(this.value)) {
          if (this.value.length) {
            await this.getEditOptions();
          }
        } else if (this.value) {
          await this.getEditOptions();
        }
        this.query.query = search;
        await this.getOptions();
      } else {
        this.options = await this.lists;
      }
      this.loading = false;
    },
    async search(search) {
      if (!this.searchableSimple) {
        this.isRequesting = true;
        this.pagination = {};
        await delete this.query.page;
        await delete this.query.query;
        if (search.length > 1) {
          this.debounceEvent(this.getOptionsOnSearch, search, 1000);
        } else {
          clearTimeout(this.interval);
          this.interval = setTimeout(async () => {
            this.interval = null;
            this.loading = true;
            this.options = await [];
            if (this.url) {
              await delete this.query.query;
              if (Array.isArray(this.value)) {
                if (this.value.length) {
                  await this.getEditOptions();
                }
              } else if (this.value) {
                await this.getEditOptions();
              }
              await this.getOptions();
            } else {
              this.options = await this.lists;
            }
            this.loading = false;
          }, 1000);
        }
        this.isRequesting = false;
      }
    },
    async onOpen() {
      if (this.hasNextPage) {
        await this.$nextTick();
        this.observer.observe(this.$refs.load);
      }
    },
    onClose() {
      this.observer.disconnect();
    },
    async getEditOptions() {
      try {
        delete this.query.query;
        if (Array.isArray(this.value)) {
          if (this.value.length) {
            this.query.conditions = [
              {
                field: "id",
                operator: "in",
                value: [...this.value.map((item) => item.id || item)],
              },
            ];
          }
        } else if (this.value) {
          this.query.conditions = [
            {
              field: "id",
              operator: "in",
              value: [this.value.id || this.value],
            },
          ];
        }
        const { data } = await this.$http.get(
          this.url.includes("panel") ? this.url : `/select/${this.url}`,
          {
            params: this.query,
            paramsSerializer: (params) => {
              return qs.stringify(this.query);
            },
          }
        );
        if (Array.isArray(this.value)) {
          if (this.value.length) {
            this.value.map(async (val, index) => {
              if (data.items) {
                this.options.push(
                  data.items.find((item) =>
                    val.id ? item.id == val.id : item.id == val
                  )
                );
              } else {
                this.options.push(
                  data.data.find((item) =>
                    val.id ? item.id == val.id : item.id == val
                  )
                );
              }
            });
            this.input = this.options.map((item) =>
              this.select ? item[this.select] : item
            );
          }
        } else if (this.value) {
          if (data.items) {
            this.options.push(
              data.items.find((item) =>
                this.value.id ? item.id == this.value.id : item.id == this.value
              )
            );
          } else {
            this.options.push(
              data.data.find((item) =>
                this.value.id ? item.id == this.value.id : item.id == this.value
              )
            );
          }
          this.input = this.options.find((item) =>
            this.select ? item[this.select] : item
          )[this.select];
        }
      } catch (err) {}
    },
    async getOptions() {
      try {
        let value = [];
        if (this.$route.fullPath.includes(this.url) && this.$route.params.id) {
          value.push(this.$route.params.id);
        }

        if (Array.isArray(this.value)) {
          if (this.value.length) {
            value.push(...this.value.map((item) => item.id || item));
          }
        } else if (this.value) {
          value.push(this.value.id || this.value);
        }
        if (value.length) {
          this.query.conditions = [
            { field: "id", operator: "nin", value: [...value] },
          ];
        } else {
          this.query.conditions = [];
        }
        (await this.hasNextPage) &&
          this.pagination.current_page &&
          (this.query.page = this.pagination.current_page + 1);
        const { data } = await this.$http.get(
          this.url.includes("panel") ? this.url : `/select/${this.url}`,
          {
            params: this.query,
            paramsSerializer: (params) => {
              return qs.stringify(this.query);
            },
          }
        );
        if (data.items) {
          this.options.push(...data.items);
        } else {
          this.options.push(...data.data);
        }
        this.pagination = data.meta.pagination;
      } catch (error) {}
    },
    async infiniteScroll([{ isIntersecting, target }]) {
      if (isIntersecting) {
        const ul = target.offsetParent;
        const scrollTop = target.offsetParent.scrollTop;

        await this.getOptions();
        this.$nextTick();
        ul.scrollTop = scrollTop;
      }
    },
  },
  computed: {
    input: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
        this.$nextTick(() => this.$emit("validate"));
      },
    },
    hasNextPage() {
      return this.isRequesting
        ? false
        : this.pagination.current_page < this.pagination.total_pages;
    },
  },
};
</script>
